import React, { useState, FC, useEffect } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
// @ts-ignore CSS side-effect imports are handled by the bundler.
import "../../styles/LabStyles.css";
import { useNavigate, useLocation } from "react-router-dom";
import { CAVSlabdeclaration, getLabMaster } from "../../api/apimethods";
import { ISampleSeverity } from "../../typings/models/SampleSeverity";
import { ITypeOfServices } from "../../typings/models/TypeOfServices";
import { IChooseApp } from "../../typings/models/ChooseApp";
import { notify } from "../../utils";
import { NotifyType } from "../../utils/app-config";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import { Button, Modal } from "react-bootstrap";
import DOMPurify from "dompurify";

const { message } = notify();

interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: string;
  nric: string;
  homeNumber: string;
  paymentMethod: string;
}

const initialPersonalInfo: PersonalInfo = {
  customerName: "Ramesh",
  mobileNumber: "+65 98765678",
  email: "jeremy.ten@gmail.com",
  address: "30 Sembawang Drive Sun Plaza Singapore 757713",
  nric: "5671",
  homeNumber: "+65 98765678",
  paymentMethod: "GIRO",
};

const typeOfApp = [
  {
    name: "Commercial",
    service: "Plant Health Diagnostics Services",
    id: 1,
  },
  {
    name: "Veterinary Biologics",
    service: "CAVS Laboratory Services",
    id: 1,
  },
  {
    name: "Aquatic",
    service: "CAVS Laboratory Services",
    id: 2,
  },
  {
    name: "Environmental",
    service: "CAVS Laboratory Services",
    id: 3,
  },
  {
    name: "Avian",
    service: "CAVS Laboratory Services",
    id: 4,
  },
  {
    name: "Terrestrial",
    service: "CAVS Laboratory Services",
    id: 5,
  },
   {
     name: "Forensics",
     service: "CAVS Laboratory Services",
     id: 6,
   },
];

const stepWizardConfig: IStepwizardProps = {
  currentStep: 1,
  steps: [
    {
      name: "Choose Application",
    },
    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

const ChooseApplication = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const state = location.state as {
    personalInfo: PersonalInfo;
    selectedType: string;
  };
  const [personalInfo, setPersonalInfo] = useState<PersonalInfo>(
    state?.personalInfo || initialPersonalInfo
  );

  const [selectedType, setSelectedType] = useState<string>(
    state?.selectedType || "Commercial"
  );
  const [selectedApplicationType, setSelectedApplicationType] =
    useState<string>("Commercial");

  const [typeOfServiceOptions, setTypeOfServiceOptions] = useState<
    ITypeOfServices[]
  >([]);
  const [valueLong, setValueLong] = useState("");
  const [chooseApp, setChooseApp] = useState<IChooseApp>({} as IChooseApp);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [typeOfApplcationOptions, setTypeofApplicationOptions] = useState<
    any[]
  >([]);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");

  useEffect(() => {
    fetchMasters();
    localStorage.removeItem("psh-app-status");
    localStorage.removeItem("modeOfPayment");
    localStorage.removeItem("psh-app-applicationNum");
    localStorage.removeItem("ismetadata");
    localStorage.removeItem("psh-action-type");
    localStorage.removeItem("psh-application-no");
    localStorage.removeItem("choose-app");
    localStorage.removeItem("profile-info");
  }, []);
  const handleChooseAppLocalStore = () => {
    localStorage.setItem("choose-app", JSON.stringify(chooseApp));
  };
  useEffect(() => {
    if (
      chooseApp &&
      chooseApp.typeOfService === "Plant Health Diagnostics Services"
    ) {
      setChooseApp((prevChooseApp) => ({
        ...prevChooseApp,
        typeOfApplication: "Commercial",
      }));
    }
  }, [chooseApp?.typeOfService]);
  useEffect(() => {
    if (chooseApp && chooseApp.typeOfService === "CAVS Laboratory Services") {
      setChooseApp((prevChooseApp) => ({
        ...prevChooseApp,
        typeOfApplication: "Veterinary Biologics",
      }));
    }
  }, [chooseApp?.typeOfService]);

  const fetchMasters = async () => {
    try {
      const response = await getLabMaster();
      if (response?.status === 200) {
        let masters = response.data.masters;

        if (masters.typeOfService) {
          let typeOfService = masters.typeOfService;
          let values: number[] = Object.values(typeOfService);

          let typeOfServiceArr: ISampleSeverity[] = Object.keys(
            typeOfService
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });

          setTypeOfServiceOptions(typeOfServiceArr);
        }
      }
    } catch (error) {
      console.error("Error fetching masters data:", error);
      navigate("/login");
    }
  };

  const handleContainerClick = () => {
    if (!isCheckboxEnabled) {
      setIsTermsModalOpen(true);
    }
  };
  const handleOptionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    type: string
  ) => {
    let newObj: any = {};
    let name = event.target.name;
    let value =
      type === "number" ? parseInt(event.target.value) : event.target.value;
    newObj[name] = value;

    if (
      name === "typeOfService" &&
      value === "Plant Health Diagnostics Services"
    ) {
      newObj["typeOfApplication"] = "Commercial";
    } else if (name === "typeOfService") {
      newObj["typeOfApplication"] = "";
    }

    setChooseApp((prevChooseApp) => ({
      ...prevChooseApp,
      ...newObj,
    }));

    if (name === "typeOfService") {
      let options = typeOfApp.filter((x) => x.service === value);
      setTypeofApplicationOptions(options);
    }
  };

  const handlePreviousClick = () => {
    navigate("/");
  };
  const handleNextClick = () => {
    let borderDanger = document.getElementsByClassName("border-danger");
    if (borderDanger.length > 0) {
      message(NotifyType.Error, "Please fill the mandatory fields.");
      return;
    }
    if (
      chooseApp.typeOfService === "CAVS Laboratory Services" &&
      !isCheckboxChecked
    ) {
      message(
        NotifyType.Error,
        "Please check the declaration checkbox in Terms & Conditions."
      );
      return;
    }
    handleChooseAppLocalStore();

    var e = document.getElementById("selectedApplicationType") as any;
      var text = e.options[e.selectedIndex].text;
      console.log("choose application", text);
    switch (text) {
      case "Commercial":
        navigate("/samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
      case "Veterinary Biologics":
        navigate("/bio-samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
      case "Aquatic":
        navigate("/aqua-samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
      case "Environmental":
        navigate("/env-samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
      case "Avian":
        navigate("/avi-samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
      case "Terrestrial":
        navigate("/ter-samples-and-tests", {
          state: {
            currentStep: 2,
            personalInfo: personalInfo,
            selectedType: selectedType,
            selectedApplicationType: selectedApplicationType,
          },
        });
        break;
         case "Forensics":
           navigate("/frw-samples-and-tests", {
             state: {
               currentStep: 2,
               personalInfo: personalInfo,
               selectedType: selectedType,
               selectedApplicationType: selectedApplicationType,
             },
           });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    fetchTestCodeMaster();
  }, []);

  const fetchTestCodeMaster = async () => {
    try {
      const response = await CAVSlabdeclaration();
      setValueLong(response.data.valueLong || "");
    } catch (error) {
      console.error("Error fetching test code master data:", error);
      navigate("/login");
    }
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked && !isCheckboxEnabled) {
      setIsTermsModalOpen(true);
      message(
        NotifyType.Error,
        "Please read the complete terms and conditions before checking the checkbox."
      );

      event.preventDefault();
      return;
    }
    setIsCheckboxChecked(event.target.checked);
  };
  const handleTermsClick = () => {
    setIsTermsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsTermsModalOpen(false);
  };
  const handleModalAdd = () => {
    if (isCheckboxEnabled) {
      setIsCheckboxChecked(true);
    }
    setIsTermsModalOpen(false);
  };
  const handleScroll = (e: React.UIEvent<HTMLLabelElement>) => {
    const target = e.target as HTMLDivElement;
    const tolerance = 1;
    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - tolerance;
    setIsCheckboxEnabled(isBottom);
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab"> Application for Laboratory Testing </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <div className="row setup-content" id="step-1">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              <div className="personal-info">
                <div className="info-heading">
                  <h2>Choose Application</h2>
                </div>

                <div className="info-content">
                  <form>
                    <div className="mb-3 row">
                      <label
                        htmlFor="selectedType"
                        className="col-sm-2 col-form-label"
                      >
                        Type Of Services<span className="star-red">*</span>
                      </label>
                      <div className="col-sm-10">
                        <select
                          className={`form-control ${
                            !chooseApp?.typeOfService
                              ? "border-danger op05"
                              : ""
                          }`}
                          aria-label="Default select example"
                          name="typeOfService"
                          value={chooseApp?.typeOfService}
                          id="selectedType"
                          onChange={(e) => handleOptionChange(e, "string")}
                        >
                          <option value=""></option>
                          {typeOfServiceOptions.map((descOption, index) => (
                            <option key={index} value={descOption.name}>
                              {descOption.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label
                        htmlFor="selectedApplicationType"
                        className="col-sm-2 col-form-label"
                      >
                        Type Of Application<span className="star-red">*</span>
                      </label>
                      <div className="col-sm-10">
                        <select
                          className={`form-control ${
                            !chooseApp?.typeOfApplication
                              ? "border-danger op05"
                              : ""
                          }`}
                          aria-label="Default select example"
                          name="typeOfApplication"
                          id="selectedApplicationType"
                          value={chooseApp?.typeOfApplication}
                          onChange={(e) => handleOptionChange(e, "number")}
                        >
                          {typeOfApplcationOptions &&
                            typeOfApplcationOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>
                      </div>
                    </div>
                    {chooseApp.typeOfService === "CAVS Laboratory Services" && (
                      <div className="form-group mt-3">
                        <div className="d-flex align-items-center">
                          <div
                            className="checkbox-container"
                            onClick={handleContainerClick}
                          >
                            <input
                              type="checkbox"
                              id="termsAndConditions"
                              name="termsAndConditions"
                              className="form-check-input me-2"
                              checked={isCheckboxChecked}
                              onChange={handleCheckboxChange}
                              disabled={!isCheckboxEnabled}
                            />
                          </div>
                          <span>I agree with the </span>
                          <Button
                            variant="link"
                            onClick={handleTermsClick}
                            className="p-0 ms-2 csp-text-decoration-none"
                          >
                            Terms & Conditions
                          </Button>
                        </div>
                      </div>
                    )}
                    {(chooseApp.typeOfService === "CAVS Laboratory Services" ||
                      chooseApp.typeOfService ===
                        "Plant Health Diagnostics Services") && (
                      <div
                        className="mt-2 csp-fs-0875 csp-text-muted"
                      >
                        <p
                          className="csp-text-red"
                        >
                          Note:
                        </p>
                        <ol>
                          <li
                            className="csp-text-red"
                          >
                            Please refer to our{" "}
                            <a
                              href={
                                chooseApp.typeOfService ===
                                "CAVS Laboratory Services"
                                  ? "https://avs.nparks.gov.sg/businesses/general-licences-services/cavs-services"
                                  : "https://www.nparks.gov.sg/services/request-plant-health-laboratories-advisory-services"
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="csp-link"
                            >
                              laboratory service booklet
                            </a>{" "}
                            for instructions on submitting service applications.
                          </li>
                          <li
                            className="csp-text-red"
                          >
                            All test applications and scheduled tests are
                            non-refundable and non-cancellable respectively,
                            once payment is made.
                          </li>
                        </ol>
                      </div>
                    )}
                  </form>
                </div>
              </div>

              <div className="text-end mt-3 mb-3">
                <button
                  className="btn btn-d btn-secondry  px-4"
                  type="button"
                  onClick={handlePreviousClick}
                >
                  Previous
                </button>
                <button
                  className="btn btn-primary nextBtn"
                  type="button"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Footer />
      <Modal
        className="popup-2"
        show={isTermsModalOpen}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Terms of Use of CAVS Laboratory Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="form-check csp-overflow-y-auto"
            onClick={handleContainerClick}
          >
            <input
              className="form-check-input mt-2 csp-w-20-h-20"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              checked={isCheckboxChecked}
              onChange={handleCheckboxChange}
              disabled={!isCheckboxEnabled}              
            />
            <label
              htmlFor="flexCheckDefault"
              className="csp-color-black csp-maxh-200 csp-overflow-y-auto csp-display-block"
              onScroll={handleScroll}
            >
              {valueLong.split("\n").map((item, index) => (
                <div key={index} className="csp-mb-5" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.trim()) }}>
                  
                </div>
              ))}
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleModalAdd}
            disabled={!isCheckboxChecked}
          >
            Accept
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChooseApplication;
